import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

export const InterviewBooking: React.FC = () => {
  const location = useLocation();

  const iframeURL = useMemo(() => {
    const raw = new URLSearchParams(location.search).get('iframeUrl');
    if (!raw) return null;

    try {
      const url = new URL(raw);
      const { hostname, protocol } = url;

      const isAllowedDomain =
        hostname === 'localhost' ||
        (protocol === 'https:' && hostname.endsWith('.agileengine.com'));

      return isAllowedDomain ? url.toString() : null;
    } catch (err) {
      console.error('Invalid iframe URL', err);
      return null;
    }
  }, [location.search]);

  if (!iframeURL) {
    return (
      <Typography color="error">
        Could not load interview booking – invalid or disallowed URL.
      </Typography>
    );
  }

  return (
    <Box
      component="iframe"
      src={iframeURL}
      width="100%"
      height="90vh"
      sandbox="allow-scripts allow-same-origin allow-forms"
      referrerPolicy="no-referrer"
      sx={{
        border: 'none',
      }}
    />
  );
};
